import React, { useState, useEffect } from 'react';
import '../styles/formStyles.css';

const API_URL = process.env.REACT_APP_API_BASE_URL;

function ClientHistoryModal({ client, visible, onClose }) {
  const [historyData, setHistoryData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (visible && client) {
      setLoading(true);
      setError('');
      setHistoryData(null);

      const fetchHistory = async () => {
        try {
          // Assumindo que um endpoint como este exista para buscar o histórico
          const response = await fetch(`${API_URL}/clients/${client.id}/history`, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          });

          if (!response.ok) {
            const errData = await response.json();
            throw new Error(errData.message || 'Falha ao buscar o histórico do cliente.');
          }

          const data = await response.json();
          setHistoryData(data);
        } catch (err) {
          setError(err.message || 'Ocorreu um erro ao carregar o histórico.');
        } finally {
          setLoading(false);
        }
      };

      fetchHistory();
    }
  }, [client, visible, token]);

  if (!visible || !client) {
    return null;
  }

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  };

  // Estilos para garantir o layout correto, contornando possíveis problemas com o arquivo CSS.
  const summaryContainerStyle = {
    backgroundColor: '#f9f9f9',
    padding: '15px',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  };

  const summaryRowStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '20px',
  };

  const summaryItemStyle = {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '800px' }}>
        <h3 style={{ borderBottom: '2px solid #C8A2C8', paddingBottom: '10px', marginBottom: '20px' }}>
          Histórico de: <span style={{ color: '#C8A2C8' }}>{client.nome}</span>
        </h3>

        {loading && <p>Carregando histórico...</p>}
        {error && <p style={{ color: 'red' }}>{error}</p>}

        {historyData && (
          <>
            <div style={summaryContainerStyle}>
              <div style={summaryRowStyle}>
                <div style={summaryItemStyle}><strong>Primeira Visita:</strong><span>{formatDate(historyData.primeira_visita)}</span></div>
                <div style={summaryItemStyle}><strong>Última Visita:</strong><span>{formatDate(historyData.ultima_visita)}</span></div>
              </div>
              <div style={summaryRowStyle}>
                <div style={summaryItemStyle}><strong>Saldo de Pontos:</strong><span>{historyData.saldo_de_pontos || 0}</span></div>
                <div style={summaryItemStyle}><strong>Pontos Resgatados:</strong><span>{historyData.pontos_resgatados || 0}</span></div>
              </div>
              <div style={summaryRowStyle}>
                <div style={summaryItemStyle}><strong>Total de Visitas:</strong><span>{historyData.total_de_visitas || 0}</span></div>
                <div style={summaryItemStyle}><strong>Total Gasto:</strong><span>{`R$ ${parseFloat(historyData.total_gasto || 0).toFixed(2)}`}</span></div>
              </div>
            </div>

            <h4 style={{ marginTop: '30px', borderTop: '1px solid #eee', paddingTop: '20px' }}>Detalhes das Visitas</h4>
            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
              <table className="dashboard-table">
                <thead>
                  <tr>
                    <th>Data</th>
                    <th>Valor da Compra</th>
                    <th>Pontos Ganhos</th>
                    <th>Pontos Resgatados</th>
                  </tr>
                </thead>
                <tbody>
                  {historyData.historico && historyData.historico.length > 0 ? (
                    historyData.historico.map((visit, index) => (
                      <tr key={visit.id || index}>
                        <td>{formatDate(visit.data_da_visita)}</td>
                        <td>{`R$ ${parseFloat(visit.valor_da_compra || 0).toFixed(2)}`}</td>
                        <td>{parseFloat(visit.valor_em_pontos || 0).toFixed(2)}</td>
                        <td>{parseFloat(visit.pontos_resgatados || 0).toFixed(2)}</td>
                      </tr>
                    ))
                  ) : (
                    <tr><td colSpan="4" style={{ textAlign: 'center' }}>Nenhuma visita registrada.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}

        <div className="button-container" style={{ justifyContent: 'flex-end', borderTop: 'none', paddingTop: '20px' }}>
          <button type="button" onClick={onClose} className="button-style cancel">
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}

export default ClientHistoryModal;